// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file tracker/v1/lander.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { DateRange, ListSort, Ownership, Pagination, PaginationMeta, TagRef } from "./common_pb.js";
import { StatsRow } from "./reporting_pb.js";
import { AttributionBasis } from "./analytics_pb.js";

/**
 * LanderType is what a page is. THANK_YOU is where a lead lands after the
 * form; the lead path picks it: the landing's own thankyou.html, else the
 * campaign's thank-you lander, else the workspace's default one for the
 * visitor's country and the landing's language.
 *
 * @generated from enum tracker.v1.LanderType
 */
export enum LanderType {
  /**
   * @generated from enum value: LANDER_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LANDER_TYPE_LANDING = 1;
   */
  LANDING = 1,

  /**
   * @generated from enum value: LANDER_TYPE_PRELANDING = 2;
   */
  PRELANDING = 2,

  /**
   * @generated from enum value: LANDER_TYPE_VSL = 3;
   */
  VSL = 3,

  /**
   * @generated from enum value: LANDER_TYPE_WHITE_PAGE = 4;
   */
  WHITE_PAGE = 4,

  /**
   * @generated from enum value: LANDER_TYPE_THANK_YOU = 5;
   */
  THANK_YOU = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(LanderType)
proto3.util.setEnumType(LanderType, "tracker.v1.LanderType", [
  { no: 0, name: "LANDER_TYPE_UNSPECIFIED" },
  { no: 1, name: "LANDER_TYPE_LANDING" },
  { no: 2, name: "LANDER_TYPE_PRELANDING" },
  { no: 3, name: "LANDER_TYPE_VSL" },
  { no: 4, name: "LANDER_TYPE_WHITE_PAGE" },
  { no: 5, name: "LANDER_TYPE_THANK_YOU" },
]);

/**
 * LanderKind is how a lander delivers the offer, and the two arms do not share
 * arithmetic:
 *
 *   REDIRECT_TO_OFFER — the page has CTAs; the visitor clicks through and a
 *                       tracker.lp_clicks row records it.
 *   OFFER_INLINE      — the offer is rendered in place via {offer_param_*}
 *                       macros; the visitor converts without leaving, so NO CTA
 *                       click-through row is produced. Reports show that column
 *                       EMPTY for such a lander, never zero, and derive CR/EPC
 *                       from lander shows — the only quantity both arms have.
 *
 * @generated from enum tracker.v1.LanderKind
 */
export enum LanderKind {
  /**
   * @generated from enum value: LANDER_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LANDER_KIND_REDIRECT_TO_OFFER = 1;
   */
  REDIRECT_TO_OFFER = 1,

  /**
   * @generated from enum value: LANDER_KIND_OFFER_INLINE = 2;
   */
  OFFER_INLINE = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(LanderKind)
proto3.util.setEnumType(LanderKind, "tracker.v1.LanderKind", [
  { no: 0, name: "LANDER_KIND_UNSPECIFIED" },
  { no: 1, name: "LANDER_KIND_REDIRECT_TO_OFFER" },
  { no: 2, name: "LANDER_KIND_OFFER_INLINE" },
]);

/**
 * @generated from enum tracker.v1.RiskStatus
 */
export enum RiskStatus {
  /**
   * @generated from enum value: RISK_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RISK_STATUS_SAFE = 1;
   */
  SAFE = 1,

  /**
   * @generated from enum value: RISK_STATUS_WARN = 2;
   */
  WARN = 2,

  /**
   * @generated from enum value: RISK_STATUS_DANGER = 3;
   */
  DANGER = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(RiskStatus)
proto3.util.setEnumType(RiskStatus, "tracker.v1.RiskStatus", [
  { no: 0, name: "RISK_STATUS_UNSPECIFIED" },
  { no: 1, name: "RISK_STATUS_SAFE" },
  { no: 2, name: "RISK_STATUS_WARN" },
  { no: 3, name: "RISK_STATUS_DANGER" },
]);

/**
 * @generated from enum tracker.v1.LanderUsageFilter
 */
export enum LanderUsageFilter {
  /**
   * every lander
   *
   * @generated from enum value: LANDER_USAGE_FILTER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LANDER_USAGE_FILTER_IN_USE = 1;
   */
  IN_USE = 1,

  /**
   * @generated from enum value: LANDER_USAGE_FILTER_UNUSED = 2;
   */
  UNUSED = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(LanderUsageFilter)
proto3.util.setEnumType(LanderUsageFilter, "tracker.v1.LanderUsageFilter", [
  { no: 0, name: "LANDER_USAGE_FILTER_UNSPECIFIED" },
  { no: 1, name: "LANDER_USAGE_FILTER_IN_USE" },
  { no: 2, name: "LANDER_USAGE_FILTER_UNUSED" },
]);

/**
 * Lander is the destination page record. Every Lander hosts an uploaded ZIP
 * served at /lander/{id}/ by the edge-router CF Worker; there is no external
 * URL field. tracking_script and click_url are materialized server-side so
 * customers always copy a fresh, macro-correct snippet.
 *
 * @generated from message tracker.v1.Lander
 */
export class Lander extends Message<Lander> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId = "";

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: int32 number_of_ctas = 5;
   */
  numberOfCtas = 0;

  /**
   * @generated from field: string tracking_domain_id = 6;
   */
  trackingDomainId = "";

  /**
   * @generated from field: string language = 8;
   */
  language = "";

  /**
   * @generated from field: repeated string country_targets = 9;
   */
  countryTargets: string[] = [];

  /**
   * Generated server-side; clients render but never write.
   *
   * @generated from field: string tracking_script = 10;
   */
  trackingScript = "";

  /**
   * @generated from field: string click_url = 11;
   */
  clickUrl = "";

  /**
   * @generated from field: string notes = 12;
   */
  notes = "";

  /**
   * @generated from field: tracker.v1.RiskStatus risk_status = 13;
   */
  riskStatus = RiskStatus.UNSPECIFIED;

  /**
   * @generated from field: repeated tracker.v1.TagRef tags = 14;
   */
  tags: TagRef[] = [];

  /**
   * @generated from field: tracker.v1.Ownership ownership = 15;
   */
  ownership?: Ownership;

  /**
   * @generated from field: string created_at = 16;
   */
  createdAt = "";

  /**
   * @generated from field: string updated_at = 17;
   */
  updatedAt = "";

  /**
   * has_content is true when the lander has a built, servable page (a current
   * active asset). Read-only, materialized on the server. The campaign form
   * flags/blocks landers where this is false so an empty page never silently
   * drops out of a rotation or back-button trap.
   *
   * @generated from field: bool has_content = 18;
   */
  hasContent = false;

  /**
   * analytics_enabled (mig 000080): when true, the direct /lander/{id}/ serve
   * injects the behavior beacon so the lander is tracked. Default false.
   *
   * @generated from field: bool analytics_enabled = 19;
   */
  analyticsEnabled = false;

  /**
   * lander_kind (mig 000094): HOW this page hands the visitor the offer. Not a
   * funnel position — is_prelander already says that — but the property that
   * decides whether a CTA click-through row exists for this lander at all.
   * UNSPECIFIED on a write means "I am not changing this", which is what keeps
   * an older client from resetting an author's choice to the enum's zero value.
   *
   * @generated from field: tracker.v1.LanderKind lander_kind = 20;
   */
  landerKind = LanderKind.UNSPECIFIED;

  /**
   * Read-only: true while lander_kind is still the upload scan's default and no
   * author has said otherwise. The UI says so rather than presenting a guess as
   * a decision.
   *
   * @generated from field: bool lander_kind_inferred = 21;
   */
  landerKindInferred = false;

  /**
   * lander_type (mig 000120): what the page IS — the landing studio's page
   * types. UNSPECIFIED on an update keeps the stored type (and is_default).
   *
   * @generated from field: tracker.v1.LanderType lander_type = 22;
   */
  landerType = LanderType.UNSPECIFIED;

  /**
   * is_default: a THANK_YOU lander that serves the leads of its language —
   * and, when country_targets names any, of those countries — on every
   * campaign that names no thank-you page of its own. Only THANK_YOU.
   *
   * @generated from field: bool is_default = 23;
   */
  isDefault = false;

  /**
   * Read-only: the version number of the current (served) asset; 0 = none.
   *
   * @generated from field: int32 current_version = 24;
   */
  currentVersion = 0;

  constructor(data?: PartialMessage<Lander>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.Lander";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "number_of_ctas", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "tracking_domain_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "country_targets", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "tracking_script", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "click_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "risk_status", kind: "enum", T: proto3.getEnumType(RiskStatus) },
    { no: 14, name: "tags", kind: "message", T: TagRef, repeated: true },
    { no: 15, name: "ownership", kind: "message", T: Ownership },
    { no: 16, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "has_content", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 19, name: "analytics_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 20, name: "lander_kind", kind: "enum", T: proto3.getEnumType(LanderKind) },
    { no: 21, name: "lander_kind_inferred", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 22, name: "lander_type", kind: "enum", T: proto3.getEnumType(LanderType) },
    { no: 23, name: "is_default", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 24, name: "current_version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Lander {
    return new Lander().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Lander {
    return new Lander().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Lander {
    return new Lander().fromJsonString(jsonString, options);
  }

  static equals(a: Lander | PlainMessage<Lander> | undefined, b: Lander | PlainMessage<Lander> | undefined): boolean {
    return proto3.util.equals(Lander, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListLandersRequest
 */
export class ListLandersRequest extends Message<ListLandersRequest> {
  /**
   * @generated from field: tracker.v1.Pagination pagination = 1;
   */
  pagination?: Pagination;

  /**
   * @generated from field: string search = 2;
   */
  search = "";

  /**
   * @generated from field: repeated string tag_ids = 3;
   */
  tagIds: string[] = [];

  /**
   * @generated from field: bool include_archived = 4;
   */
  includeArchived = false;

  /**
   * Landers by their own id — a screen naming the landers it already shows.
   *
   * @generated from field: repeated string ids = 5;
   */
  ids: string[] = [];

  /**
   * name | updated_at | risk_status | created_at (default: created_at, newest first).
   *
   * @generated from field: tracker.v1.ListSort sort = 6;
   */
  sort?: ListSort;

  /**
   * Only landers of these types; empty = every type.
   *
   * @generated from field: repeated tracker.v1.LanderType types = 7;
   */
  types: LanderType[] = [];

  /**
   * Only landers in these languages (ISO 639-1, as stored); empty = any.
   *
   * @generated from field: repeated string languages = 8;
   */
  languages: string[] = [];

  /**
   * Only landers that target any of these countries (ISO 3166-1 alpha-2); empty = any.
   *
   * @generated from field: repeated string countries = 9;
   */
  countries: string[] = [];

  /**
   * Only landers flagged so; empty = any.
   *
   * @generated from field: repeated tracker.v1.RiskStatus risk_statuses = 10;
   */
  riskStatuses: RiskStatus[] = [];

  /**
   * «Используется»: served by a live campaign (an enabled lander node of a
   * campaign that is not archived — the library's «в кампаниях») or not.
   *
   * @generated from field: tracker.v1.LanderUsageFilter usage = 11;
   */
  usage = LanderUsageFilter.UNSPECIFIED;

  constructor(data?: PartialMessage<ListLandersRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListLandersRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: Pagination },
    { no: 2, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "tag_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "include_archived", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "sort", kind: "message", T: ListSort },
    { no: 7, name: "types", kind: "enum", T: proto3.getEnumType(LanderType), repeated: true },
    { no: 8, name: "languages", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 9, name: "countries", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "risk_statuses", kind: "enum", T: proto3.getEnumType(RiskStatus), repeated: true },
    { no: 11, name: "usage", kind: "enum", T: proto3.getEnumType(LanderUsageFilter) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListLandersRequest {
    return new ListLandersRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListLandersRequest {
    return new ListLandersRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListLandersRequest {
    return new ListLandersRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListLandersRequest | PlainMessage<ListLandersRequest> | undefined, b: ListLandersRequest | PlainMessage<ListLandersRequest> | undefined): boolean {
    return proto3.util.equals(ListLandersRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListLandersResponse
 */
export class ListLandersResponse extends Message<ListLandersResponse> {
  /**
   * @generated from field: repeated tracker.v1.Lander items = 1;
   */
  items: Lander[] = [];

  /**
   * @generated from field: tracker.v1.PaginationMeta pagination = 2;
   */
  pagination?: PaginationMeta;

  constructor(data?: PartialMessage<ListLandersResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListLandersResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: Lander, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationMeta },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListLandersResponse {
    return new ListLandersResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListLandersResponse {
    return new ListLandersResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListLandersResponse {
    return new ListLandersResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListLandersResponse | PlainMessage<ListLandersResponse> | undefined, b: ListLandersResponse | PlainMessage<ListLandersResponse> | undefined): boolean {
    return proto3.util.equals(ListLandersResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetLanderRequest
 */
export class GetLanderRequest extends Message<GetLanderRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetLanderRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetLanderRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLanderRequest {
    return new GetLanderRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLanderRequest {
    return new GetLanderRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLanderRequest {
    return new GetLanderRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetLanderRequest | PlainMessage<GetLanderRequest> | undefined, b: GetLanderRequest | PlainMessage<GetLanderRequest> | undefined): boolean {
    return proto3.util.equals(GetLanderRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetLanderResponse
 */
export class GetLanderResponse extends Message<GetLanderResponse> {
  /**
   * @generated from field: tracker.v1.Lander lander = 1;
   */
  lander?: Lander;

  constructor(data?: PartialMessage<GetLanderResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetLanderResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "lander", kind: "message", T: Lander },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLanderResponse {
    return new GetLanderResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLanderResponse {
    return new GetLanderResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLanderResponse {
    return new GetLanderResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetLanderResponse | PlainMessage<GetLanderResponse> | undefined, b: GetLanderResponse | PlainMessage<GetLanderResponse> | undefined): boolean {
    return proto3.util.equals(GetLanderResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateLanderRequest
 */
export class CreateLanderRequest extends Message<CreateLanderRequest> {
  /**
   * @generated from field: tracker.v1.Lander lander = 1;
   */
  lander?: Lander;

  constructor(data?: PartialMessage<CreateLanderRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateLanderRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "lander", kind: "message", T: Lander },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateLanderRequest {
    return new CreateLanderRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateLanderRequest {
    return new CreateLanderRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateLanderRequest {
    return new CreateLanderRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateLanderRequest | PlainMessage<CreateLanderRequest> | undefined, b: CreateLanderRequest | PlainMessage<CreateLanderRequest> | undefined): boolean {
    return proto3.util.equals(CreateLanderRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateLanderResponse
 */
export class CreateLanderResponse extends Message<CreateLanderResponse> {
  /**
   * @generated from field: tracker.v1.Lander lander = 1;
   */
  lander?: Lander;

  constructor(data?: PartialMessage<CreateLanderResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateLanderResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "lander", kind: "message", T: Lander },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateLanderResponse {
    return new CreateLanderResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateLanderResponse {
    return new CreateLanderResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateLanderResponse {
    return new CreateLanderResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateLanderResponse | PlainMessage<CreateLanderResponse> | undefined, b: CreateLanderResponse | PlainMessage<CreateLanderResponse> | undefined): boolean {
    return proto3.util.equals(CreateLanderResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateLanderRequest
 */
export class UpdateLanderRequest extends Message<UpdateLanderRequest> {
  /**
   * @generated from field: tracker.v1.Lander lander = 1;
   */
  lander?: Lander;

  constructor(data?: PartialMessage<UpdateLanderRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateLanderRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "lander", kind: "message", T: Lander },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateLanderRequest {
    return new UpdateLanderRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateLanderRequest {
    return new UpdateLanderRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateLanderRequest {
    return new UpdateLanderRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateLanderRequest | PlainMessage<UpdateLanderRequest> | undefined, b: UpdateLanderRequest | PlainMessage<UpdateLanderRequest> | undefined): boolean {
    return proto3.util.equals(UpdateLanderRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateLanderResponse
 */
export class UpdateLanderResponse extends Message<UpdateLanderResponse> {
  /**
   * @generated from field: tracker.v1.Lander lander = 1;
   */
  lander?: Lander;

  constructor(data?: PartialMessage<UpdateLanderResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateLanderResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "lander", kind: "message", T: Lander },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateLanderResponse {
    return new UpdateLanderResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateLanderResponse {
    return new UpdateLanderResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateLanderResponse {
    return new UpdateLanderResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateLanderResponse | PlainMessage<UpdateLanderResponse> | undefined, b: UpdateLanderResponse | PlainMessage<UpdateLanderResponse> | undefined): boolean {
    return proto3.util.equals(UpdateLanderResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.ArchiveLanderRequest
 */
export class ArchiveLanderRequest extends Message<ArchiveLanderRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<ArchiveLanderRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ArchiveLanderRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ArchiveLanderRequest {
    return new ArchiveLanderRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ArchiveLanderRequest {
    return new ArchiveLanderRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ArchiveLanderRequest {
    return new ArchiveLanderRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ArchiveLanderRequest | PlainMessage<ArchiveLanderRequest> | undefined, b: ArchiveLanderRequest | PlainMessage<ArchiveLanderRequest> | undefined): boolean {
    return proto3.util.equals(ArchiveLanderRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ArchiveLanderResponse
 */
export class ArchiveLanderResponse extends Message<ArchiveLanderResponse> {
  constructor(data?: PartialMessage<ArchiveLanderResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ArchiveLanderResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ArchiveLanderResponse {
    return new ArchiveLanderResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ArchiveLanderResponse {
    return new ArchiveLanderResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ArchiveLanderResponse {
    return new ArchiveLanderResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ArchiveLanderResponse | PlainMessage<ArchiveLanderResponse> | undefined, b: ArchiveLanderResponse | PlainMessage<ArchiveLanderResponse> | undefined): boolean {
    return proto3.util.equals(ArchiveLanderResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.DuplicateLanderRequest
 */
export class DuplicateLanderRequest extends Message<DuplicateLanderRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string new_name = 2;
   */
  newName = "";

  constructor(data?: PartialMessage<DuplicateLanderRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DuplicateLanderRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "new_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DuplicateLanderRequest {
    return new DuplicateLanderRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DuplicateLanderRequest {
    return new DuplicateLanderRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DuplicateLanderRequest {
    return new DuplicateLanderRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DuplicateLanderRequest | PlainMessage<DuplicateLanderRequest> | undefined, b: DuplicateLanderRequest | PlainMessage<DuplicateLanderRequest> | undefined): boolean {
    return proto3.util.equals(DuplicateLanderRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.DuplicateLanderResponse
 */
export class DuplicateLanderResponse extends Message<DuplicateLanderResponse> {
  /**
   * @generated from field: tracker.v1.Lander lander = 1;
   */
  lander?: Lander;

  constructor(data?: PartialMessage<DuplicateLanderResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DuplicateLanderResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "lander", kind: "message", T: Lander },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DuplicateLanderResponse {
    return new DuplicateLanderResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DuplicateLanderResponse {
    return new DuplicateLanderResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DuplicateLanderResponse {
    return new DuplicateLanderResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DuplicateLanderResponse | PlainMessage<DuplicateLanderResponse> | undefined, b: DuplicateLanderResponse | PlainMessage<DuplicateLanderResponse> | undefined): boolean {
    return proto3.util.equals(DuplicateLanderResponse, a, b);
  }
}

/**
 * LanderUsage counts the active (non-archived) flows + campaigns that
 * reference the lander. Backs the "Used in N flows" picker badge.
 *
 * @generated from message tracker.v1.LanderUsage
 */
export class LanderUsage extends Message<LanderUsage> {
  /**
   * @generated from field: int32 flow_count = 1;
   */
  flowCount = 0;

  /**
   * @generated from field: int32 campaign_count = 2;
   */
  campaignCount = 0;

  /**
   * @generated from field: repeated string flow_ids = 3;
   */
  flowIds: string[] = [];

  constructor(data?: PartialMessage<LanderUsage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.LanderUsage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "flow_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "campaign_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "flow_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LanderUsage {
    return new LanderUsage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LanderUsage {
    return new LanderUsage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LanderUsage {
    return new LanderUsage().fromJsonString(jsonString, options);
  }

  static equals(a: LanderUsage | PlainMessage<LanderUsage> | undefined, b: LanderUsage | PlainMessage<LanderUsage> | undefined): boolean {
    return proto3.util.equals(LanderUsage, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetLanderUsageRequest
 */
export class GetLanderUsageRequest extends Message<GetLanderUsageRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetLanderUsageRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetLanderUsageRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLanderUsageRequest {
    return new GetLanderUsageRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLanderUsageRequest {
    return new GetLanderUsageRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLanderUsageRequest {
    return new GetLanderUsageRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetLanderUsageRequest | PlainMessage<GetLanderUsageRequest> | undefined, b: GetLanderUsageRequest | PlainMessage<GetLanderUsageRequest> | undefined): boolean {
    return proto3.util.equals(GetLanderUsageRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetLanderUsageResponse
 */
export class GetLanderUsageResponse extends Message<GetLanderUsageResponse> {
  /**
   * @generated from field: tracker.v1.LanderUsage usage = 1;
   */
  usage?: LanderUsage;

  constructor(data?: PartialMessage<GetLanderUsageResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetLanderUsageResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "usage", kind: "message", T: LanderUsage },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLanderUsageResponse {
    return new GetLanderUsageResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLanderUsageResponse {
    return new GetLanderUsageResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLanderUsageResponse {
    return new GetLanderUsageResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetLanderUsageResponse | PlainMessage<GetLanderUsageResponse> | undefined, b: GetLanderUsageResponse | PlainMessage<GetLanderUsageResponse> | undefined): boolean {
    return proto3.util.equals(GetLanderUsageResponse, a, b);
  }
}

/**
 * The library's tiles: counts over EVERY lander of the workspace that is not
 * archived. Its traffic is the report engine's (GetBreakdownDrilldown by
 * «landing»), never a second count here.
 *
 * @generated from message tracker.v1.GetLanderLibraryRequest
 */
export class GetLanderLibraryRequest extends Message<GetLanderLibraryRequest> {
  constructor(data?: PartialMessage<GetLanderLibraryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetLanderLibraryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLanderLibraryRequest {
    return new GetLanderLibraryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLanderLibraryRequest {
    return new GetLanderLibraryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLanderLibraryRequest {
    return new GetLanderLibraryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetLanderLibraryRequest | PlainMessage<GetLanderLibraryRequest> | undefined, b: GetLanderLibraryRequest | PlainMessage<GetLanderLibraryRequest> | undefined): boolean {
    return proto3.util.equals(GetLanderLibraryRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetLanderLibraryResponse
 */
export class GetLanderLibraryResponse extends Message<GetLanderLibraryResponse> {
  /**
   * @generated from field: int64 landers = 1;
   */
  landers = protoInt64.zero;

  /**
   * @generated from field: int64 with_domain = 2;
   */
  withDomain = protoInt64.zero;

  /**
   * @generated from field: int64 languages = 3;
   */
  languages = protoInt64.zero;

  /**
   * risk WARN or DANGER
   *
   * @generated from field: int64 risky = 4;
   */
  risky = protoInt64.zero;

  /**
   * Landers a live campaign serves («в кампаниях»).
   *
   * @generated from field: int64 in_campaigns = 7;
   */
  inCampaigns = protoInt64.zero;

  /**
   * Of them, flagged DANGER («1 опасный в работе»).
   *
   * @generated from field: int64 danger_in_campaigns = 8;
   */
  dangerInCampaigns = protoInt64.zero;

  constructor(data?: PartialMessage<GetLanderLibraryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetLanderLibraryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "landers", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "with_domain", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "languages", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "risky", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "in_campaigns", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "danger_in_campaigns", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLanderLibraryResponse {
    return new GetLanderLibraryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLanderLibraryResponse {
    return new GetLanderLibraryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLanderLibraryResponse {
    return new GetLanderLibraryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetLanderLibraryResponse | PlainMessage<GetLanderLibraryResponse> | undefined, b: GetLanderLibraryResponse | PlainMessage<GetLanderLibraryResponse> | undefined): boolean {
    return proto3.util.equals(GetLanderLibraryResponse, a, b);
  }
}

/**
 * LanderNumbers is one lander's row of the library: the report's numbers for
 * the period, how many live campaigns serve it.
 *
 * @generated from message tracker.v1.LanderNumbers
 */
export class LanderNumbers extends Message<LanderNumbers> {
  /**
   * @generated from field: string lander_id = 1;
   */
  landerId = "";

  /**
   * The report engine's row for dimension «landing» — what
   * GetBreakdownDrilldown answers for that lander and period.
   *
   * @generated from field: tracker.v1.StatsRow stats = 2;
   */
  stats?: StatsRow;

  /**
   * @generated from field: tracker.v1.StatsRow compare = 3;
   */
  compare?: StatsRow;

  /**
   * @generated from field: int32 campaign_count = 4;
   */
  campaignCount = 0;

  constructor(data?: PartialMessage<LanderNumbers>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.LanderNumbers";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "lander_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "stats", kind: "message", T: StatsRow },
    { no: 3, name: "compare", kind: "message", T: StatsRow },
    { no: 4, name: "campaign_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LanderNumbers {
    return new LanderNumbers().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LanderNumbers {
    return new LanderNumbers().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LanderNumbers {
    return new LanderNumbers().fromJsonString(jsonString, options);
  }

  static equals(a: LanderNumbers | PlainMessage<LanderNumbers> | undefined, b: LanderNumbers | PlainMessage<LanderNumbers> | undefined): boolean {
    return proto3.util.equals(LanderNumbers, a, b);
  }
}

/**
 * ListLanderNumbers answers the numbers of the landers on screen over the
 * app's one period, from the report engine (the reporting registry's
 * metrics); `totals` is the engine's «Итого» over exactly these landers.
 * The lander card's «Цифры» (by campaign, by country, by day) is
 * GetBreakdownDrilldown filtered by dimension «landing».
 *
 * @generated from message tracker.v1.ListLanderNumbersRequest
 */
export class ListLanderNumbersRequest extends Message<ListLanderNumbersRequest> {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[] = [];

  /**
   * @generated from field: tracker.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  /**
   * @generated from field: tracker.v1.AttributionBasis attribution_basis = 3;
   */
  attributionBasis = AttributionBasis.UNSPECIFIED;

  /**
   * @generated from field: repeated string metric_keys = 4;
   */
  metricKeys: string[] = [];

  /**
   * @generated from field: tracker.v1.DateRange compare_range = 5;
   */
  compareRange?: DateRange;

  constructor(data?: PartialMessage<ListLanderNumbersRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListLanderNumbersRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "date_range", kind: "message", T: DateRange },
    { no: 3, name: "attribution_basis", kind: "enum", T: proto3.getEnumType(AttributionBasis) },
    { no: 4, name: "metric_keys", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "compare_range", kind: "message", T: DateRange },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListLanderNumbersRequest {
    return new ListLanderNumbersRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListLanderNumbersRequest {
    return new ListLanderNumbersRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListLanderNumbersRequest {
    return new ListLanderNumbersRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListLanderNumbersRequest | PlainMessage<ListLanderNumbersRequest> | undefined, b: ListLanderNumbersRequest | PlainMessage<ListLanderNumbersRequest> | undefined): boolean {
    return proto3.util.equals(ListLanderNumbersRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListLanderNumbersResponse
 */
export class ListLanderNumbersResponse extends Message<ListLanderNumbersResponse> {
  /**
   * @generated from field: repeated tracker.v1.LanderNumbers items = 1;
   */
  items: LanderNumbers[] = [];

  /**
   * @generated from field: tracker.v1.StatsRow totals = 2;
   */
  totals?: StatsRow;

  /**
   * @generated from field: tracker.v1.StatsRow compare_totals = 3;
   */
  compareTotals?: StatsRow;

  constructor(data?: PartialMessage<ListLanderNumbersResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListLanderNumbersResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: LanderNumbers, repeated: true },
    { no: 2, name: "totals", kind: "message", T: StatsRow },
    { no: 3, name: "compare_totals", kind: "message", T: StatsRow },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListLanderNumbersResponse {
    return new ListLanderNumbersResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListLanderNumbersResponse {
    return new ListLanderNumbersResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListLanderNumbersResponse {
    return new ListLanderNumbersResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListLanderNumbersResponse | PlainMessage<ListLanderNumbersResponse> | undefined, b: ListLanderNumbersResponse | PlainMessage<ListLanderNumbersResponse> | undefined): boolean {
    return proto3.util.equals(ListLanderNumbersResponse, a, b);
  }
}

/**
 * LanderCampaign is one live campaign that serves the lander — the board
 * «Где используется».
 *
 * @generated from message tracker.v1.LanderCampaign
 */
export class LanderCampaign extends Message<LanderCampaign> {
  /**
   * @generated from field: string campaign_id = 1;
   */
  campaignId = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: string status = 3;
   */
  status = "";

  /**
   * @generated from field: string owner_id = 4;
   */
  ownerId = "";

  /**
   * The campaign's link (https://{domain}/{path}); "" without a domain.
   *
   * @generated from field: string url = 5;
   */
  url = "";

  /**
   * A managed campaign (Setup) states its lander shares: share_bp is this
   * lander's share of them in basis points (10000 = the only lander) and
   * lander_count how many landers the rotation has. A hand-built flow's
   * shares are its graph's: managed=false and both 0.
   *
   * @generated from field: bool managed = 6;
   */
  managed = false;

  /**
   * @generated from field: int32 share_bp = 7;
   */
  shareBp = 0;

  /**
   * @generated from field: int32 lander_count = 8;
   */
  landerCount = 0;

  /**
   * The offers the campaign sends this traffic to (managed campaigns).
   *
   * @generated from field: repeated string offer_ids = 9;
   */
  offerIds: string[] = [];

  constructor(data?: PartialMessage<LanderCampaign>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.LanderCampaign";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "owner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "managed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "share_bp", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "lander_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "offer_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LanderCampaign {
    return new LanderCampaign().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LanderCampaign {
    return new LanderCampaign().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LanderCampaign {
    return new LanderCampaign().fromJsonString(jsonString, options);
  }

  static equals(a: LanderCampaign | PlainMessage<LanderCampaign> | undefined, b: LanderCampaign | PlainMessage<LanderCampaign> | undefined): boolean {
    return proto3.util.equals(LanderCampaign, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListLanderCampaignsRequest
 */
export class ListLanderCampaignsRequest extends Message<ListLanderCampaignsRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<ListLanderCampaignsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListLanderCampaignsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListLanderCampaignsRequest {
    return new ListLanderCampaignsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListLanderCampaignsRequest {
    return new ListLanderCampaignsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListLanderCampaignsRequest {
    return new ListLanderCampaignsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListLanderCampaignsRequest | PlainMessage<ListLanderCampaignsRequest> | undefined, b: ListLanderCampaignsRequest | PlainMessage<ListLanderCampaignsRequest> | undefined): boolean {
    return proto3.util.equals(ListLanderCampaignsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListLanderCampaignsResponse
 */
export class ListLanderCampaignsResponse extends Message<ListLanderCampaignsResponse> {
  /**
   * @generated from field: repeated tracker.v1.LanderCampaign items = 1;
   */
  items: LanderCampaign[] = [];

  constructor(data?: PartialMessage<ListLanderCampaignsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListLanderCampaignsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: LanderCampaign, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListLanderCampaignsResponse {
    return new ListLanderCampaignsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListLanderCampaignsResponse {
    return new ListLanderCampaignsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListLanderCampaignsResponse {
    return new ListLanderCampaignsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListLanderCampaignsResponse | PlainMessage<ListLanderCampaignsResponse> | undefined, b: ListLanderCampaignsResponse | PlainMessage<ListLanderCampaignsResponse> | undefined): boolean {
    return proto3.util.equals(ListLanderCampaignsResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.SetLanderAnalyticsRequest
 */
export class SetLanderAnalyticsRequest extends Message<SetLanderAnalyticsRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: bool enabled = 2;
   */
  enabled = false;

  constructor(data?: PartialMessage<SetLanderAnalyticsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.SetLanderAnalyticsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetLanderAnalyticsRequest {
    return new SetLanderAnalyticsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetLanderAnalyticsRequest {
    return new SetLanderAnalyticsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetLanderAnalyticsRequest {
    return new SetLanderAnalyticsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SetLanderAnalyticsRequest | PlainMessage<SetLanderAnalyticsRequest> | undefined, b: SetLanderAnalyticsRequest | PlainMessage<SetLanderAnalyticsRequest> | undefined): boolean {
    return proto3.util.equals(SetLanderAnalyticsRequest, a, b);
  }
}

